<style>
    .watchlist-product{
        border-radius: 10px;
    }
    .watchlist-product .card-body{
        padding: 12px 16px;
    }
    .watchlist-product .dropdown-menu{
        width: 100%;
        max-width: 340px;
        background: var(--background-color);
    }
    .watchlist-product .dropdown-menu > div{
        overflow: auto;
        max-height: 320px;
    }
    .watchlist-product .dropdown-submenu{
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none; /* Standard syntax */
    }
    .watchlist-product .discount-badge{
        padding: 3px 6px;
        border-radius: 5px;
        color: white;
    }
    .watchlist-product .previous-price{
        color: var(--text-subtle);
        text-decoration: line-through;
        opacity: 0.6;
    }
</style>

<script>
    import {shopifyHelperMixin} from "../../mixins/shopifyHelperMixin";

    export default {
        props: ['product'],
        components: {

        },
        mixins: [shopifyHelperMixin],
        data: function () {
            return {
                loading: {
                    watchlist: false
                },
                watchlist: null
            }
        },
        computed: {
            price_change_count: function(){
                var count = 0;
                var price_history = this.product.price_history || [];
                
                for(var i=0; i < price_history.length; i++){
                    var item = price_history[i];
                    if(item.price_change !== 0){
                        count++;
                    }
                }
                return count;
            },
            has_discount: function(){
                return this.last_price_change && this.last_price_change.price_change < 0;
            },
            has_increase: function(){
                return this.last_price_change && this.last_price_change.price_change > 0;
            },
            last_price_change: function(){
                var history = this.product.price_history || [];
                for(var i= history.length - 1; i >= 0; i--){
                    var item = history[i];
                    if(item.price_change !== 0){
                        return item;
                    }
                }
            },
            discount_percentage: function(){
                if(this.last_price_change){
                    return Math.round(Math.abs(this.last_price_change.price_change));
                }
            }
        },
        created: function () {

        },
        mounted: function () {
            var self = this;

        },
        methods: {
            getPriceChangeDate: function(){
                //Find the date when the price last changed (it won't always be the last item)
                if(!this.product.price_history || !this.product.price_history.length){
                    return;
                }
                
                var history = this.product.price_history;
                var index = -1; //Default value will be the last item
                for(var i = history.length - 1; i >= 0; i--){
                    var item = history[i];
                    if(item.price_change !== 0){
                        index = i;
                        break;
                    }
                }
                if(index === -1){
                    return '';
                }
                var last_price = history[index];
                var date = last_price.date;

                if(typeof date === 'string'){
                    return moment.tz(date).fromNow();
                } else if(typeof date === 'object'){
//                    date.$date.$numberLong
                }
                
            },
            calculatePreviousPrice: function(item){
                var discount_percentage = item.price_change;
                if(discount_percentage !== 0){
                    if(discount_percentage === 100){
                        return item.price;
                    }
                    var previous_price = item.price / (1 + discount_percentage / 100);
//                    previous_price = Math.round(previous_price / 10) * 10;
                    return previous_price;
                }
                
                return item.price;
            },
            getPreviousPrice: function(item, index){
                var previous_item = this.product.price_history[index - 1];
                if(previous_item){
                    return previous_item.price;
                }
                
                //If it's the first item
                return this.calculatePreviousPrice(item);
            },
            getDate: function(item){
                if(typeof item.date === 'string'){
                    return this.formatDate(item.date, 'MMMM DD, YYYY');
                }
                return '-';
            },
            getPriceDifference: function(item, index){
                var previous_item = this.product.price_history[index - 1];
                if(previous_item){
                    var previous_price = previous_item.price;
                    if(previous_price === 0 && item.price > 0){
                        item.price_change = 100; //Fix for price change being 0 when going from $0 to a higher price
                    }
                } else {
                    //Calculate the difference based on the price change
                    var previous_price = this.calculatePreviousPrice(item);
                }
                
                var diff = item.price - previous_price;
                var sign = '';
                if(diff > 0){
                    sign = '+';
                } else if(diff < 0){
                    sign = '-';
                }
                diff = Math.abs(diff);
                return sign + this.formatCurrency(diff);
            },
            removeFromWatchlist: function(){
                var self = this;
                if(self.loading.watchlist) {
                    return;
                }
                self.loading.watchlist = true;
                var url = '/api/v5/shop/watchlist/remove';
                var params = {
                    product_ids: [this.product.id],
                    append: ['products']
                };
                axios.post(url, params).then(function (response) {
                    self.watchlist = response.data.data;
                    self.loading.watchlist = false;
                    self.$emit('removed', self.product);
                    self.showWatchlistSnackbar(false);
                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.loading.watchlist = false;
                });
            },
            showWatchlistSnackbar: function(added){
                var self = this;
                var snackbar = {
                    pos: 'bottom-center'
                };
                if(this.product.images && this.product.images.length){
                    snackbar.image_url = this.product.images[0].src;
                }
                
                if(added){
                    snackbar.text = 'Item added to your <br><strong>watchlist</strong>';
                    snackbar.action_text = 'Undo';
                    snackbar.action_callback = function(){
                        self.removeFromWatchlist();
                    };
                } else {
                    snackbar.text = '<strong>Item removed from watchlist!</strong>';
                }
                if(typeof RDSnackbar === 'object'){
                    RDSnackbar.show(snackbar);
                } else {
                    Snackbar.show(snackbar);
                }
            }
        }
    };

</script>

<template>
    <div class="card watchlist-product">
        <div class="card-body">
            <div class="row row-sm justify-content-between align-items-center mb-1">
                <div class="col-auto">
                    <span class="text-success" v-if="has_discount">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
                            <path d="M13.6001 11.357L16.2387 10.7932L17.3708 8.34411L17.3225 12.1496L13.6001 11.357Z" fill="#0AC252"/>
                            <path d="M0.791992 1.35687L5.57403 7.34169L10.4233 3.51507L16.2387 10.7932M16.2387 10.7932L13.6001 11.357L17.3225 12.1496L17.3708 8.34411L16.2387 10.7932Z" stroke="#0AC252" stroke-width="2" stroke-linejoin="round"/>
                        </svg>
                        <span class="style-body-large align-middle">New lower price!</span>
                    </span>
                    <span class="text-danger" v-else-if="has_increase">
                        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.6001 3.64301L16.2387 4.20678L17.3708 6.65589L17.3225 2.85039L13.6001 3.64301Z" fill="#BB262D"/>
                            <path d="M0.791992 13.6431L5.57403 7.65831L10.4233 11.4849L16.2387 4.20678M16.2387 4.20678L13.6001 3.64301L17.3225 2.85039L17.3708 6.65589L16.2387 4.20678Z" stroke="#BB262D" stroke-width="2" stroke-linejoin="round"/>
                        </svg>
                        <span class="style-body-large align-middle">Price increased</span>
                    </span>
                </div>
                <div class="col-auto text-subtle">
                    <span>{{getPriceChangeDate(product)}}</span>
                    <i class="fas fa-trash-alt fa-fw pointer ml-2" @click="removeFromWatchlist"></i>
                </div>
                
            </div>
            <div class="row row-sm flex-nowrap justify-content-between mb-2">
                <div class="col-auto" v-if="product.images && product.images.length">
                    <img class="fit-cover rounded lazyload" height="44" width="44" :alt="product.title" :data-src="product.images[0].src">
                </div>
                <div class="col">
                    <div class="font-weight-bold mb-2">
                        <a class="text-reset" :href="'/shop/products/' + product.id">
                            {{product.title}}
                        </a>
                    </div>
                    <div v-if="last_price_change">
                        <span class="previous-price">{{formatCurrency(calculatePreviousPrice(last_price_change))}}</span>
                        <i class="fas fa-arrow-right mx-1"></i>
                        <span :class="{'text-success': last_price_change.price_change < 0, 'text-danger': last_price_change.price_change > 0}">
                        {{formatCurrency(last_price_change.price)}}
                        </span>
                        <span class="discount-badge bg-success ml-2" v-if="last_price_change.price_change < 0">
                            SAVE {{discount_percentage}}%
                        </span>
                    </div>
                    <div v-else>
                        {{formatCurrency(product.unit_price)}}
                    </div>
                </div>
            </div>
            
            <div class="dropdown-submenu">
                <span class="dropdown-btn pointer">
                    <span v-if="price_change_count === 0">
                        No price changes
                    </span>
                    <span v-else>
                        {{price_change_count}} price 
                        <template v-if="price_change_count === 1">change</template>
                        <template v-else>changes</template>
                    </span>
                </span>
                <div class="dropdown-menu py-3">
                    <div class="px-3">
                        <div class="style-section-title text-center mb-4">Product Price History</div>
                        <div class="row row-sm justify-content-between my-3" v-for="(item, i) in product.price_history" >
                            <div class="col-auto">
                                <span class="previous-price">{{formatCurrency(getPreviousPrice(item, i))}}</span>
                                <template v-if="item.price_change < 0">
                                    <i class="fas fa-arrow-down text-success mx-1"></i>
                                </template>
                                <template v-else-if="item.price_change > 0">
                                    <i class="fas fa-arrow-up text-danger mx-1"></i>
                                </template>
                                <template v-else>
                                    <i class="fas fa-arrow-right mx-1"></i>
                                </template>
                                <span class="" :class="{'text-success': item.price_change < 0, 'text-danger': item.price_change > 0}">
                                    {{formatCurrency(item.price)}}
                                    ({{getPriceDifference(item, i)}})  
                                </span>
                            </div>
                            <div class="col-auto text-subtle">
                                {{getDate(item)}}
                            </div>
                        </div>
                    </div>

                    
                </div>
            </div>
            
            
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/watchlist/watchlistProduct.vue